export default {
  name: 'marking--articlesMapUpload',
  apiService: 'shoes',
  apiPath: '/admin/article_map/upload',
  urlParamName: 'marking--articlesMapUpload',
};